import React from 'react';
import { Button } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import { useAppSelector } from 'src/hooks';
import { AppI } from 'src/redux';
import styles from './WhatsAppBubble.module.css';

const WhatsAppBubble = () => {
   const { locale } = useAppSelector(({ app }: { app: AppI }) => app);

   const whatsappLinks: Record<string, string> = {
      'es-ES': 'https://wa.me/525510790688',
      'en': 'https://wa.me/12108787819',
      'es': 'https://wa.me/525510790688',
      'co': 'https://wa.me/573107699490',
   };

   const whatsappLink: string = whatsappLinks[locale as string] || whatsappLinks['es'];

   return (
      <a
         href={whatsappLink}
         target='_blank'
         rel='noreferrer'
         className={styles.whatsapp_bubble}
      >
         <Button
            shape='circle'
            icon={<WhatsAppOutlined style={{ color: '#FFFFFF', fontSize: 24 }} />}
            size='large'
            style={{ backgroundColor: '#25D366', border: 'none' }}
         />
      </a>
   );
};

export default WhatsAppBubble;
